<kendo-dialog-titlebar>
    {{'shared.header.chooseUser' | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <form [formGroup]="form">
        <app-user-select-ctrl [caption]="label | translate" [settings]="{fxFill:true}"
            [formControlName]="'selectedUserId'"></app-user-select-ctrl>
    </form>
    
    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>